const SignUpFormMapper = {
    first_name: "نام",
    last_name: "نام خانوادگی",
    father_name: "نام پدر",
    birth_date: "تاریخ تولد",
    age: "سن",
    city_born: "شهر تولد",
    country_born: "کشور محل سکونت",
    job: "شغل",
    gender: "جنسیت",
    marital_status: "وضعیت تاهل",
    major: "رشته تحصیلی",
    education_stage: "مدرک تحصیلی",
    home_number: "شماره تلفن منزل",
    phone_number: "شماره تلفن همراه",
    mother_phone: "شماره تلفن مادر",
    father_phone: "شماره تلفن پدر",
    address: "آدرس",
    desired_plan: "علاقه‌مند به یادگیری کدامیک از برنامه های زبان انگلیسی هستید؟",
    introduced_by: "از چه طریق با موسسه ما آشنا شدید؟",
    learning_experience_years: "چند سال به یادگیری زبان پرداخته اید؟",
    former_instructor: "در کجا:",
    former_book: "چه کتابی:",
    about_me: "جمله‌ای درمورد خودتان بنویسید:"
}
export default SignUpFormMapper;


